module.exports = __webpack_public_path__ + "img/hero-03.2135bc58.jpg";